import React from 'react';

import Input from 'components/fields/Input';
import Checkbox from 'components/fields/Checkbox';

const FormParticipation = ({
  onFieldChange,
  name_required,
  email_required,
  cc_required,
  phone_required,
  address_required,
  postal_required,
  city_required,
  meo_id_required,
  agreement_required,
  name_placeholder,
  email_placeholder,
  cc_placeholder,
  phone_placeholder,
  address_placeholder,
  postal_placeholder,
  city_placeholder,
  meo_id_placeholder,
  agreement_placeholder,
  rules,
}) => {
  const fields = [
    {
      name: 'name',
      type: 'text',
      label: name_placeholder || 'Nome',
      required: name_required,
    },
    {
      name: 'email',
      type: 'email',
      label: email_placeholder || 'E-mail',
      required: email_required,
    },
    {
      name: 'cc',
      type: 'tel',
      label: cc_placeholder || 'BI/CC',
      pattern: '[0-9]{8}((?:-|| )[0-9]{1}[A-Z]{2}[0-9]{1})?',
      required: cc_required,
    },
    {
      name: 'phone',
      type: 'tel',
      label: phone_placeholder || 'Telefone',
      pattern: '9[1236][0-9]{7}|2[1-9][0-9]{7}',
      required: phone_required,
    },
    {
      name: 'address',
      type: 'text',
      label: address_placeholder || 'Morada',
      required: address_required,
    },
    {
      name: 'postal',
      type: 'tel',
      label: postal_placeholder || 'Código Postal',
      pattern: '[1-9]{1}[0-9]{3}(-[0-9]{3})?',
      required: postal_required,
    },
    {
      name: 'local',
      type: 'text',
      label: city_placeholder || 'Localidade',
      required: city_required,
    },
    {
      name: 'meoId',
      type: 'tel',
      label: meo_id_placeholder || 'Numero de cliente MEO',
      pattern: '^[0-9]+$',
      required: meo_id_required,
    },
    {
      name: 'agreement',
      type: 'checkbox',
      label: agreement_placeholder || 'Li e concordo com o {regulamento}',
      required: agreement_required,
      url: rules,
    },
  ];
  return (
    <>
      {fields
        .filter(field => field.required === true)
        .map(field =>
          field.type === 'checkbox' ? (
            <Checkbox key={field.name} onFieldChange={onFieldChange} {...field} />
          ) : (
            <Input key={field.name} onFieldChange={onFieldChange} {...field} />
          )
        )}
    </>
  );
};

export default FormParticipation;
